import Link from '@mui/material/Link';
import { observer } from 'mobx-react-lite';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { useHasPermission } from '../../auth';
import { userDetailPath } from '../../routes/routes';

/**
 * A person's name in «Площадка» (AUT-542, «Ссылки на людей»): a link to the
 * user card only for an operator with `manage_users` (without it `/users`
 * does not open — architect B1); otherwise plain text. No name (account
 * deleted) — «—».
 */
export interface PersonLinkProps {
  userId: string | null;
  name: string | null;
}

const PersonLinkInner = ({ userId, name }: PersonLinkProps): ReactElement => {
  const { t } = useTranslation();
  const canOpenUser = useHasPermission('manage_users');

  if (!name) return <>{t('marketplace.empty')}</>;
  if (!canOpenUser || !userId) return <>{name}</>;
  return (
    <Link component={RouterLink} to={userDetailPath(userId)} underline="hover">
      {name}
    </Link>
  );
};

export const PersonLink = observer(PersonLinkInner);
